import React from "react";
import { Box, Button } from "@mui/material";
import BarcodeScanner from "../../../common/BarcodeScanner";

const ActionButtons = ({ onCancel, onSave, isLoading = false, onBarcodeDetected, onBarcodeError }) => {
  return (
    <Box sx={{ 
      display: "flex", 
      flexDirection: { xs: 'column', sm: 'row' }, 
      alignItems: { xs: 'stretch', sm: 'center' }, 
      gap: 1, 
      justifyContent: { xs: 'flex-end', sm: 'space-between' }, 
    
      pt: 1, 
      px: 0,
      backgroundColor: "#fff", 
      borderRadius: 0 
    }}>
      <Box sx={{ display: "flex", justifyContent: { xs: 'flex-end', sm: 'flex-start' } }}>
        {/* <BarcodeScanner onDetected={onBarcodeDetected} onError={onBarcodeError} /> */}
      </Box>
      <Box sx={{ display: "flex", flexDirection: { xs: 'column', sm: 'row' }, gap: 1, justifyContent: "flex-end", width: { xs: '100%', sm: 'auto' } }}>
        <Button 
          variant="outlined" 
          size="medium" 
          fullWidth 
          onClick={onCancel}
          disabled={isLoading}

          sx={{ 
            borderColor: "#F8991D",
            whiteSpace: 'nowrap',
            fontWeight: 500,
            "&:hover": {
              backgroundColor: "#F8991D",
              color: "#fff",
              boxShadow: "none",
            },
            '&.MuiButton-outlined': { 
              height: '32px', 
              maxWidth: { sm: '170px' } 
            } 
          }}
        >
          Cancel & Exit
        </Button>
        <Button 
          variant="contained" 
          size="medium" 
          fullWidth 
          onClick={onSave}
          disabled={isLoading}
          sx={{ 
            whiteSpace: 'nowrap',
            fontWeight: 500,
            '&.MuiButton-contained': { 
              backgroundColor: "#F8991D", 
              color: "#fff", 
              height: '32px', 
              maxWidth: { sm: '170px' } 
            } 
          }}
        >
          {isLoading ? "Saving..." : "Save & Exit"}
        </Button>
      </Box>
    </Box>
  );
};

export default ActionButtons;

